export default {"src":"/_next/static/media/icloud.0c9d0538.svg","height":2432,"width":2500,"blurWidth":0,"blurHeight":0};